import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import WorkspaceInvite from "@/pages/invitation/WorkspaceInvite";

const searchSchema = z.object({
  id: z.string(),
  isAccepted: z.coerce.boolean().default(true),
});

export const Route = createFileRoute("/_secure/workspace-invite")({
  validateSearch: zodValidator(searchSchema),
  component: WorkspaceInvite,
});
